if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"forge","remotes":[],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return 763 != chunkId},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}